// Generated by scripts/generate-public-surface.ts. Do not edit.

import type { CountryValidator } from "../../types";

import { createValidator } from "#stdnum-runtime";

const dic: CountryValidator<"CZ"> = createValidator(
  "cz.dic",
  48,
);

export default dic;
export const compact = dic.compact;
export const format = dic.format;
export const validate = dic.validate;
export const generate = (): string =>
  dic.generate?.() ??
  (() => {
    throw new Error(
      "Validator cz.dic cannot generate values",
    );
  })();
